import React from "react";
import GeneralBloc from "../../../bloc/general_bloc";
import "./app_content_field_item2.css";
import LanguageBloc from "../../../bloc/language_bloc";
// import Labels from "../../constant/labels";

class AppContentFieldItem3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: props.title,
            value: props.value,
        };
    }

    stateTitle() {
        return this.state.title;
    }
    stateValue() {
        let value = this.state.value;

        return value;
    }

    componentDidMount() { }

    render() {
        return (
            <div className="d-flex app-content-field-container align-items-center justify-content-between my-3"
                style={{ border: `${this.props.borderless == false ? "1px" : "0px"} solid #D9D9D9` }}
            >
                <div className="d-flex align-items-center">
                    <div className="app-content-field-icon">
                        {
                            this.props.type == 'PDF' ?
                                <img
                                    src={GeneralBloc.getAssetsContextPath() + `/assets/icons/PDF.svg`}
                                    alt="Backwards"
                                    className="mr-2"
                                /> :
                                <img
                                    src={GeneralBloc.getAssetsContextPath() + `/assets/icons/JPG.svg`}
                                    alt="Backwards"
                                    className="mr-2"
                                />
                        }
                    </div>
                    <div className="app-content-field-content" onClick={() => {
                        if (!this.props.showPreview) {
                            this.props.onView("id")
                        }
                    }}>
                        <div className="app-content-field-title">
                            {this.props.title}
                        </div>
                        <div className="app-content-field-info">
                            {/* {this.props.type}. */}
                            {this.props?.size || 3 } MB <span style={{color: '#62B5C6'}}>{this.props.status}</span>
                            {/* {this.props.value} */}
                        </div>

                        {/* {this.stateValue() || ""} */}
                    </div>
                    {
                        this.props.showPreview && this.props.from == "proposal" && this.props.showPreview == true && <div className={`${this.props.flow == "client" ? 'client-view' : 'ml-5'} ${this.state.hadClicked == true ? "document_previewed_text" : "document_preview_text"}`} onClick={() => {
                            this.setState({
                                hadClicked: true
                            })
                            this.props.onView("id")
                        }}>{
                                "LanguageBloc.getTextByCode(Labels.LBL_PREVIEW_SUBMIT)"
                            }</div>
                    }
                </div>
                <div>
                    {
                        this.props.showDeleteIcon == true && <img onClick={() => this.props.onDelete()}
                            src={GeneralBloc.getAssetsContextPath() + `/assets/icons/trash.svg`}
                            alt="Backwards"
                            className="mr-2"
                        />
                    }

                </div>
                {
                    this.props.showPreview && this.props.from == "quotation" && this.props.showPreview == true && <div className={`${this.props.flow == "client" ? 'client-view' : 'ml-5'}  ${this.state.hadClicked == true ? "document_previewed_text" : "document_preview_text"}`} onClick={() => {
                        this.setState({
                            hadClicked: true
                        })
                        this.props.onView("id")
                    }}>{
                            "LanguageBloc.getTextByCode(Labels.LBL_PREVIEW_SUBMIT)"
                        }</div>
                }

            </div>
        );
    }
}

export default AppContentFieldItem3;
